export interface IUnsavedPromptProps {
  isUnsaved: boolean;
}

const UnsavedPrompt = ({ isUnsaved }: IUnsavedPromptProps) => {
  return <></>;
};
export default UnsavedPrompt;
